'use client';

import Link from 'next/link';
import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

const locations = [
{
  id: 'loc1',
  nameIT: 'Alice Beach',
  nameEN: 'Alice Beach',
  cityIT: 'Via Leonardo Da Vinci, Villaggi, NO',
  cityEN: 'Via Leonardo Da Vinci, Villaggi, NO',
  descIT: 'Una delle spiagge più accoglienti del Lago Maggiore. Dog friendly, facilmente accessibile, con parcheggio comodo e numerosi servizi. Un ambiente informale ma curato, ideale per chi cerca una location completa e aperta a tutti.',
  descEN: 'One of the most welcoming beaches on Lake Maggiore. Dog-friendly and easily accessible, with convenient parking and a wide range of amenities. An informal yet well-kept atmosphere, open to everyone.',
  img: "/assets/images/spiaggia_alice_beach-1773435101786.jpg",
  alt: 'Panoramic view of Alice Beach on Lake Maggiore with calm waters and scenic surroundings',
  active: true
},
{
  id: 'loc2',
  nameIT: 'Spiaggia Miami',
  nameEN: 'Spiaggia Miami',
  cityIT: 'Via Novara, 69, Orta San Giulio, NO',
  cityEN: 'Via Novara, 69, Orta San Giulio, NO',
  descIT: 'Una realtà curata sul Lago d\'Orta, con ristorante, bar e servizi attrezzati. Affacciata su acque calme e cristalline, è il luogo ideale per godersi il lago con stile e tranquillità.',
  descEN: 'A refined venue on Lake Orta, with a restaurant, bar, and fully equipped services. Overlooking calm, crystal-clear waters — the perfect place to enjoy the lake with style and tranquillity.',
  img: "/assets/images/foto_spiaggia_miami-1773431325078.jpg",
  alt: 'Aerial view of Alice Beach on Lake Maggiore with clear blue water and sandy shore',
  active: true
}];


export default function LocationsPreview({ lang = 'it' }: {lang?: 'it' | 'en';}) {
  return (
    <section style={{ padding: 'var(--section-pad) 0' }}>
      <div className="container-main">
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <div className="badge badge-cyan" style={{ marginBottom: '12px' }}>
            <Icon name="MapPinIcon" size={12} variant="solid" />
            {lang === 'it' ? 'Le nostre location' : 'Our locations'}
          </div>
          <h2
            style={{
              fontFamily: 'Fraunces, Georgia, serif',
              fontSize: 'clamp(1.8rem, 5vw, 3rem)',
              fontWeight: 700,
              letterSpacing: '-0.02em'
            }}>
            
            {lang === 'it' ? 'Lago Maggiore & Lago d\'Orta' : 'Lake Maggiore & Lake Orta'}
          </h2>
        </div>

        <div
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3"
          style={{
            gap: '20px'
          }}>
          
          {locations.map((loc) =>
          <div key={loc.id} className="location-card">
              <div style={{ position: 'relative', aspectRatio: '16/9', overflow: 'hidden' }}>
                <AppImage
                src={loc.img}
                alt={loc.alt}
                fill
                className="object-cover"
                style={{ objectFit: 'cover', transition: 'transform 0.6s ease' }} />
              
                <div
                style={{
                  position: 'absolute',
                  inset: 0,
                  background: 'linear-gradient(to top, rgba(11,31,46,0.8) 0%, transparent 50%)'
                }} />
              
                <div className="badge badge-green" style={{ position: 'absolute', top: '12px', right: '12px', fontSize: '10px' }}>
                  <span style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#25D366', display: 'inline-block' }} />
                  {lang === 'it' ? 'Attiva' : 'Active'}
                </div>
              </div>
              <div style={{ padding: '20px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px' }}>
                  <Icon name="MapPinIcon" size={14} variant="solid" style={{ color: '#00D4FF' }} />
                  <span style={{ fontSize: '12px', color: '#00D4FF', fontWeight: 600 }}>
                    {lang === 'it' ? loc.cityIT : loc.cityEN}
                  </span>
                </div>
                <h3 style={{ fontSize: '18px', fontWeight: 700, marginBottom: '8px' }}>
                  {lang === 'it' ? loc.nameIT : loc.nameEN}
                </h3>
                <p style={{ fontSize: '13px', color: 'rgba(240,247,255,0.6)', lineHeight: 1.6, marginBottom: '16px' }}>
                  {lang === 'it' ? loc.descIT : loc.descEN}
                </p>
                <Link
                href={`/booking?location=${loc.id}`}
                className="btn-secondary"
                style={{ fontSize: '13px', padding: '10px 16px' }}>
                
                  {lang === 'it' ? 'Prenota qui' : 'Book here'}
                  <Icon name="ArrowRightIcon" size={14} />
                </Link>
              </div>
            </div>
          )}

          {/* Coming soon card */}
          <div
            style={{
              background: 'rgba(18,41,64,0.5)',
              border: '1px dashed rgba(240,247,255,0.12)',
              borderRadius: '24px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '40px 24px',
              gap: '12px',
              textAlign: 'center',
              minHeight: '280px'
            }}>
            
            <div
              style={{
                width: '56px',
                height: '56px',
                borderRadius: '50%',
                background: 'rgba(232,169,77,0.1)',
                border: '1px solid rgba(232,169,77,0.2)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
              
              <Icon name="MapPinIcon" size={24} style={{ color: '#E8A94D' }} />
            </div>
            <h3 style={{ fontSize: '16px', fontWeight: 700, color: 'rgba(240,247,255,0.6)' }}>
              {lang === 'it' ? 'Nuove location in arrivo' : 'New locations coming'}
            </h3>
            <p style={{ fontSize: '13px', color: 'rgba(240,247,255,0.35)', maxWidth: '200px', lineHeight: 1.5 }}>
              {lang === 'it' ? 'Stiamo espandendo la nostra rete sul Lago Maggiore, Lago d\'Orta e oltre.' : 'We\'re expanding our network on Lake Maggiore, Lake Orta and beyond.'}
            </p>
            <div className="badge badge-gold" style={{ fontSize: '10px' }}>
              {lang === 'it' ? 'Prossimamente' : 'Coming soon'}
            </div>
          </div>
        </div>
      </div>
    </section>);

}